import React from 'react';
import { useSelector } from 'react-redux';
import { useState, useEffect } from "react";
import useSnackbar from '../../../hooks/useSnackbar';

import { billCreditRelatedRecTransactionsTable, billCreditRelatedRecReimbursementsTable } from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';

import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, Tabs, Tab, CircularProgress } from '@mui/material';
import TabPanel from "../../../components/TabPanel";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

export default function CheckRelatedRecords({ tabIndexP }) {

  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  
  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  // useEffect(() => {
  //   if (user.token && tabIndexP === 4) {
  //   }
  // }, [tabIndexP]);

  return (
    <>
      <Box className="viewBox sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-bkg1"
        >
          <Tab label="Reimbursements" />
         
        </Tabs>

        {/*Reimbursements*/}
        <TabPanel value={tabIndex} index={0}>
          {tabIndexP === 2 ?
            <AgGridPaginatedTable 
            // getTableRows={getTransactionNotAvailable}
              columns={billCreditRelatedRecReimbursementsTable}
              perPage={5}
              refreshCounter={0}
            />
            : <></>
          }
        </TabPanel>
        {/*Reimbursements*/}

        

      </Box>
    </>
  )
}



